/* ===========================
   Subcollections (Flickity)
   =========================== */
jQuery(document).ready(function($){
  function Subcollections(container) {
    this.$container = $(container);
    this.$slider = this.$container.find('.slider');
    this.flkty = null;
    this.listenEvent = this.checkForSlider.bind(this);
    this.init();
  }
  Subcollections.prototype = $.extend({}, Subcollections.prototype, {
    init: function() {
      this.checkForSlider();
      this.listen();
    },
    initSlider: function() {
      this.flkty = this.$slider.flickity({
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        wrapAround: false,
        groupCells: true,
        contain: true,
      });
    },
    destroySlider: function() {
      if (this.flkty) {
        this.$slider.flickity("destroy");
        this.flkty = null;
      }
    },
    checkForSlider: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;
      if (windowWidth >= 768) {
        if (!this.flkty) this.initSlider();
      } else {
        this.destroySlider();
      }
    },
    listen: function() {
      window.addEventListener("resize", this.listenEvent);
    },
    onUnload: function() {
      window.removeEventListener("resize", this.listenEvent);
    },
  });
});

/* ===========================
   Cart count updater
   =========================== */
function updateCountPrice(cart) {
  jQuery(".cart__count").each(function() {
    jQuery(this).toggleClass("cart__count--has-items", !!cart.item_count);
  });
  jQuery(".cart-count__number").text(cart.item_count);
}
document.addEventListener('cart:change', function(event) {
  const cart = event.detail.cart;
  updateCountPrice(cart);
});

/* ===========================
   Helpers dinero
   =========================== */
function formatearPrecio(precio) {
  return (precio / 100).toFixed(2).replace('.', ',') + ' €';
}
function formatMoney(amount, format) {
  var value = (amount / 100).toFixed(2);
  const formatWithDelimiters = (value) => {
    let parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  };
  switch(format) {
    case "${{amount}}": return "$" + formatWithDelimiters(value);
    default: return formatWithDelimiters(value) + " €";
  }
}

// Helper para uso interno en funciones globales
function money(cents) {
    try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, Shopify.moneyFormat); }
    catch (_) {}
    const n = Number(cents || 0) / 100;
    return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

/* ===========================
   Helpers Globales
   =========================== */

function setFormatSpanTextOnce($span, value) {
    const cleanLabel = (text) => {
        let normalized = String(text || '').replace(/[\s\u00A0]+/g, ' ').trim();

        // 1. Regex Mejorada: Detecta duplicados "Texto | Texto"
        const regexRepeticion = /^(.+?)(\s*\|\s*|\s+)\1$/;
        if (regexRepeticion.test(normalized)) {
            return normalized.replace(regexRepeticion, '$1');
        }

        // 2. Limpieza estándar de "Pack X uds"
        const dedupPattern = /(Pack[\s\u00A0]*\d+[\s\u00A0]*uds?)([\s\u00A0]*\1)+/ig;
        normalized = normalized.replace(dedupPattern, '$1');

        // 3. Limpieza de Shopify "Opción / Opción"
        if (normalized.includes(' / ')) {
             const parts = normalized.split(' / ');
             if (parts.length === 2 && parts[0].trim() === parts[1].trim()) {
                 return parts[0].trim();
             }
        }
        return normalized;
    };

    const labelLimpia = cleanLabel(value);
    
    if ($span && $span.length) {
        $span.text(labelLimpia);

        let obs = $span.data('packObserver');
        if (!obs) {
            obs = new MutationObserver(() => {
                const currentText = $span.text();
                const dedupedText = cleanLabel(currentText);
                if (currentText !== dedupedText) {
                    obs.disconnect();
                    $span.text(dedupedText);
                    try { obs.observe($span[0], { childList: true, characterData: true, subtree: true }); } catch (_) {}
                }
            });
            try { obs.observe($span[0], { childList: true, characterData: true, subtree: true }); } catch (_) {}
            $span.data('packObserver', obs);
        }
    }
}

/* ===========================
   Toast simple
   =========================== */
function showToast(message) {
  const toastContainer = document.getElementById('toast-container');
  if (!toastContainer) return;
  const toast = document.createElement('div');
  toast.className = 'toast show';
  toast.innerText = message;
  toastContainer.appendChild(toast);
  setTimeout(() => {
    toast.classList.remove('show');
    toast.addEventListener('transitionend', () => toastContainer.removeChild(toast));
  }, 3000);
}


/* =========================================================
   Metafields en mini-cart / drawer (pinta formato + medidas)
   ========================================================= */
   
document.addEventListener('DOMContentLoaded', function() {
  handleProductHandles('.line-item-url', 'product-format-');
  handleProductHandles('.line-item-url-drawer', 'product-format-drawer');
});
document.addEventListener('cart:change', function() {
  setTimeout(function() {
    handleProductHandles('.line-item-url', 'product-format-');
    handleProductHandles('.line-item-url-drawer', 'product-format-drawer');
  }, 500);
});
function handleProductHandles(selector, formatPrefix) {
  var productHandles = [];
  document.querySelectorAll(selector).forEach(function(element, index) {
    var productHandle = element.getAttribute('data-url');
    if (productHandle) {
      var match = productHandle.match(/\/products\/([a-z0-9\-]+)(\?.*)?/);
      if (match && match[0]) {
        productHandles.push({handle: match[0], index: index});
      }
    }
  });
  var formatPromises = productHandles.map((item) => getProductMetafieldsFormato(item.handle, item.index));
  Promise.all(formatPromises).then(results => {
    results.forEach(result => {
      const element = document.getElementById(formatPrefix + result.index);
      if (!element) return;
      if (result.displayTitle && result.medidas) {
        element.textContent = result.medidas + " | " + result.displayTitle;
      } else if (result.displayTitle) {
        element.textContent = result.displayTitle;
      } else if (result.medidas) {
        element.textContent = result.medidas;
      } else {
        element.textContent = "";
      }
    });
  }).catch(error => console.error('Error metafields:', error));
}
function getProductMetafieldsFormato(productHandle, index) {
  var url = productHandle + '&view=metafields-general-variants';
  return fetch(url)
    .then(response => { if(!response.ok) throw new Error('Network'); return response.json(); })
    .then(metafields => {
      var tituloVariante = metafields.tituloVariante ? metafields.tituloVariante : null;
      var formato = metafields.formato ? metafields.formato[0] : null;
      var medidas = metafields.medidas ? metafields.medidas : null;
      var displayTitle = (tituloVariante && tituloVariante !== "Default Title") ? tituloVariante : formato;
      return { displayTitle, medidas, index };
    });
}

/* ===========================
   UX móvil: ocultar tags extra (3º en adelante + 2º si provoca overflow)
   =========================== */
function esMovil() { return /Mobi|Android/i.test(navigator.userAgent); }
document.addEventListener('DOMContentLoaded', () => {
  if (!esMovil()) return;
  document.querySelectorAll('.product-card').forEach(card => {
    card.querySelectorAll('.product__badges').forEach(container => {
      const tags = container.querySelectorAll('.product__tag');
      // Ocultar desde el 3º en adelante (solo 2 máximo)
      for (let i = 2; i < tags.length; i++) tags[i].style.display = 'none';
      // Si el 2º desborda el ancho del contenedor, también ocultarlo
      if (tags.length >= 2 && container.scrollWidth > container.clientWidth + 1) {
        tags[1].style.display = 'none';
      }
    });
  });
});

/* =========================================================
   Bloqueo de emojis en inputs “properties[Línea …]”
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('input[name^="properties[Línea"]');
  const emojiRE = /\p{Extended_Pictographic}/gu;
  inputs.forEach(input => {
    input.addEventListener('input', () => {
      if (emojiRE.test(input.value)) input.value = input.value.replace(emojiRE, '');
    });
    input.addEventListener('paste', e => {
      e.preventDefault();
      const raw = (e.clipboardData || window.clipboardData).getData('text');
      const clean = raw.replace(emojiRE, '');
      if (document.queryCommandSupported?.('insertText')) {
        document.execCommand('insertText', false, clean);
      } else {
        const start = input.selectionStart, end = input.selectionEnd;
        input.setRangeText(clean, start, end, 'end');
      }
    });
  });
});

/* =========================================================
   PDP: listener de cambio de variante (no interfiere con cards)
   ========================================================= */
document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant;
  if (!variant) return;

  var newVariantPrice = variant.price;
  function updatePricesPDP() {
    jQuery('.price-with-vat').show();
    jQuery('.price-without-vat').show();
  }
  updatePricesPDP();
  jQuery('#switch-ht').off('change._pdp').on('change._pdp', updatePricesPDP);

  let priceWithVatElement = document.getElementById('price-with-vat');
  if (priceWithVatElement) {
    priceWithVatElement.innerHTML = `<b style="font-size:18px; color:black;">${formatearPrecio((newVariantPrice).toFixed(2))} </b>`;
  }
  jQuery("#formato-variante").text(variant.public_title);

  var url = window.location.href + '&view=metafields';
  fetch(url).then(r => { if(!r.ok) throw new Error('Network'); return r.json(); })
    .then(metafields => {
      jQuery(".tab-features__value-format").text(variant.public_title);
      jQuery(".tab-features__value-color-variant").text(metafields.color_variant);
      jQuery(".product__box-content").text(metafields.caja);
      jQuery(".product__sku").text(metafields.referencia);
      jQuery("#price-vat-unidad").text(metafields.precio_unidad);
      jQuery("#price-no-vat-unidad").text(metafields.precio_unidad_sin_vat);
    })
    .catch(()=>{});
});


/* =========================================================
   >>> NUEVAS FUNCIONES GLOBALES (Extraídas para corregir B2B) <<<
   ========================================================= */

function updateHeader($card, product) {
    $card.find('.product-title')
      .attr('href', product.url)
      .html('<h3 style="font-weight:600;">' + product.title + '</h3>');
    $card.find('.product-card__media').attr('href', product.url);
}

function updateImages($card, product) {
    // If the card uses the new image carousel, delegate to its public API and stop.
    const gallery = $card[0] && $card[0].querySelector('product-card-gallery');
    if (gallery && typeof gallery.rebuildSlides === 'function') {
      gallery.rebuildSlides(product.media || []);
      return;
    }

    // Legacy fallback: rewrite primary + secondary <img> attributes in place.
    if (product.media?.length) {
      const p0 = product.media[0].preview_image?.src || product.media[0].src;
      if (p0) {
        const srcset = [200,300,400,500,600,700,800].map(w => `${p0}?width=${w} ${w}w`).join(', ');
        $card.find('.product-card__image--primary').attr({ src: p0, srcset });
      }
    }
    if (product.media?.length > 1) {
      const p1 = product.media[1].preview_image?.src || product.media[1].src;
      if (p1) {
        const srcset = [200,300,400,500,600,700,800].map(w => `${p1}?width=${w} ${w}w`).join(', ');
        $card.find('.product-card__image--secondary').attr({ src: p1, srcset });
      }
    }
}

function updatePrices($card, price, compare) {
    const $sale = $card.find('sale-price');
    let $cmp = $card.find('compare-at-price');
    $sale.text(money(price));
    const showCompare = compare && Number(compare) > Number(price);
    if (showCompare) {
      if (!$cmp.length) {
        $card.find('sale-price').after('<compare-at-price class="h6 text-subdued line-through"></compare-at-price>');
        $cmp = $card.find('compare-at-price');
      }
      $cmp.text(money(compare)).show();
      $sale.removeClass('text-subdued').addClass('text-on-sale');
    } else {
      $cmp.hide();
      $sale.removeClass('text-on-sale').addClass('text-subdued');
    }
}

function updateColorDiscountBadge($card, product) {
    const $container = $card.find('.product-card__discount-badge');
    if (!$container.length || $container.attr('data-discount-enabled') === 'false') return;

    const firstVariant = product.variants?.[0] || null;
    const activePrice = firstVariant ? firstVariant.price : product.price;
    const activeCompare = firstVariant ? firstVariant.compare_at_price : product.compare_at_price;
    const price = Number(activePrice ?? 0);
    const compare = Number(activeCompare ?? 0);
    const onSale = compare > price;

    $container.prop('hidden', !onSale);
    if (!onSale) return;

    const discountPercentage = Math.round((compare - price) * 100 / compare);
    const $badge = jQuery('<on-sale-badge>', {
      class: 'badge badge--on-sale',
    }).text(`-${discountPercentage}%`);
    const $badgeList = jQuery('<badge-list>', { class: 'badge-list' }).append($badge);

    $container.empty().append($badgeList);
}

function updateVariant($card, variant) {
    const available = !!variant?.available;
    $card.find("input[name='id']").val(variant?.id || '');
    const $btn = $card.find(".cantidad-add-cart button[type='submit']");
    const $qty = $card.find('.quantity-selector__input');
    $btn
      .prop('disabled', !available)
      .toggleClass('agotado', !available)
      .html('<span class="sr-only">Añadir a la cesta</span>' + (available ? 'Añadir' : 'Agotado'));
    $qty.prop('disabled', !available).val(available ? 1 : 0);
    $card.find('.decrease-quantity, .increase-quantity').prop('disabled', !available);
}

async function loadProduct($card, handle) {
    const [product, meta] = await Promise.all([
      jQuery.getJSON('/products/' + handle + '.js'),
      fetch('/products/' + handle + '?view=metafields-general').then(r => r.ok ? r.json() : null).catch(() => null),
    ]);

    updateHeader($card, product);
    updateImages($card, product);

    const v0 = product.variants?.[0] || null;
    updatePrices($card, product.price ?? v0?.price ?? 0, product.compare_at_price ?? v0?.compare_at_price ?? 0);
    updateVariant($card, v0);
    
    return product;
}

/* =========================================================
   >>> CORE UNIFICADO: Color + Formato en product-card <<<
   ========================================================= */
(function ($) {
  const SEL = {
    card: '.product-card',
    colorSwatch: '.related-products-wrapper .color-swatch',
    formatList: '.related-products-wrapper-formato .related-product-list-formato',
    formatLink: '.related-products-wrapper-formato .related-product-list-formato a, a.formato__link', // fallback
    sizeText: '.product-grid-item__size',
    features: '.product-grid__features',
    mediaLink: '.product-card__media',
    titleLink: '.product-title',
    imgPrimary: '.product-card__image--primary',
    imgSecondary: '.product-card__image--secondary',
    salePrice: 'sale-price',
    compareAtPrice: 'compare-at-price',
    form: "form[is='product-form']",
    inputId: "input[name='id']",
    addBtn: ".cantidad-add-cart button[type='submit']",
    qtyInput: '.quantity-selector__input',
    btnDec: '.decrease-quantity',
    btnInc: '.increase-quantity',
    colorActual: '.color-actual',
  };

  // --- Utils ---
  function parseHandleFromHref(hrefOrData) {
    if (!hrefOrData) return null;
    const m = String(hrefOrData).match(/\/products\/([a-z0-9\-]+)/i);
    return m?.[1] || null;
  }
  
  function setActive($siblings, $target) {
    $siblings.removeClass('active is-selected');
    $target.addClass('active is-selected');
  }

  function renderFeatures($card, medidas, label) {
    const $features = $card.find(SEL.features);
    
    // 1. Limpiamos las medidas y el label para compararlos
    let medidasClean = String(medidas || '').replace(/\s*\|\s*Pack[^|]+$/i, '').trim();
    const labelClean = String(label || '').trim();

    // 2. Lógica de Fusión Inteligente:
    if (medidasClean && labelClean.includes(medidasClean)) {
        medidasClean = '';
    }

    // 3. Solo añadimos el prefijo con barra "|" si realmente quedan medidas diferentes que mostrar
    const prefix = medidasClean ? `${medidasClean}&nbsp;|&nbsp;` : '';

    // 4. Formato fijo (eje Talla): persiste tras el click si el card lo expone y no está ya en el label
    const fixedFormato = String($features.attr('data-fixed-formato') || '').trim();
    const suffix = (fixedFormato && !labelClean.includes(fixedFormato))
      ? `&nbsp;|&nbsp;<span class="product-grid-item__size">${fixedFormato}</span>`
      : '';

    if ($features.length) {
      $features.html(`${prefix}<span id="format-size" class="product-grid-item__size"></span>${suffix}`);
      setFormatSpanTextOnce($features.find('#format-size'), label);
    } else {
      const $size = $card.find(SEL.sizeText);
      if ($size.length) setFormatSpanTextOnce($size, label);
    }
  }

  // Construye la lista de formatos y deja el pack activo + features
  function buildFormatsFromMeta($card, meta, currentHandle) {
    if (!meta?.Formatos?.length) return false;

    const html = meta.Formatos.map(f => `
      <a data-handle="${f.handle}" href="/products/${f.handle}"
         class="formato-swatch size__link" style="width:auto; margin-right:5px; line-height:14px;">
        ${f.metafields?.magento_formato || f.title || 'Formato'}
      </a>
    `).join('');
    $card.find(SEL.formatList).html(html);

    const $links = $card.find(SEL.formatLink);
    let $match = $links.filter(function () {
      return parseHandleFromHref(jQuery(this).attr('href')) === currentHandle;
    }).first();
    if (!$match.length) $match = $links.first();
    setActive($links, $match);

    // Label del pack (limpio por si viniera repetido)
    let label = ($match.text() || '').replace(/\s+/g,' ').trim();
    label = label.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');

    const medidas = Array.isArray(meta.medidas) ? meta.medidas[0] : meta.medidas;
    renderFeatures($card, medidas, label);

    return true;
  }

  // Click FORMATO (enlaces estándar B2C)
  $(document).on('click', SEL.formatLink, async function (e) {
    e.preventDefault();
    const $a = $(this);
    const $card = $a.closest(SEL.card);

    // ¿Es variante del MISMO producto? (usa data-* o ?variant=)
    const variantIdFromData = $a.data('variant-id');
    const variantIdFromHref = (($a.attr('href') || '').match(/[?&]variant=(\d+)/) || [])[1];
    const isSameProductVariant = !!(variantIdFromData || variantIdFromHref);

    if (isSameProductVariant) {
      // --- VARIANTE LOCAL: actualizamos en caliente sin fetch ---
      setActive($card.find(SEL.formatLink), $a);

      const vId = String(variantIdFromData || variantIdFromHref);
      const vPrice = Number($a.data('variant-price') || 0);
      const vCompare = Number($a.data('variant-compare-price') || 0);
      const vAvail = String($a.data('variant-available')) === 'true';

      // Precio + compare (usando la función global ahora)
      updatePrices($card, vPrice, vCompare);

      // Formulario / botón / qty (usando la función global ahora)
      updateVariant($card, { id: vId, available: vAvail });

      // Texto del formato (evitamos duplicados "Pack XX uds")
      const labelRaw = ($a.text() || '').trim();
      const label = labelRaw.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');

      // Pintar en features (manteniendo medidas si existen).
      // En productos con eje Talla el card expone data-medidas (puede ser ''),
      // así evitamos confundir la talla con la medida al parsear el texto.
      const $featuresEl = $card.find(SEL.features);
      const currentFeatures = $featuresEl.text() || '';
      const medidas = $featuresEl.is('[data-medidas]')
        ? String($featuresEl.attr('data-medidas') || '').trim()
        : currentFeatures.split('|')[0].trim();
      renderFeatures($card, medidas, label);

      return; // ¡listo!
    }

    // --- FORMATO CON OTRO HANDLE: seguimos con el flujo de carga ---
    const handle = parseHandleFromHref($a.attr('href')) || $a.data('handle');
    if (!handle) return;

    setActive($card.find(SEL.formatLink), $a);
    try { 
        // 1. Cargar producto (Global)
        await loadProduct($card, handle); 

        // 2. ACTUALIZACIÓN VISUAL DEL TEXTO (Formato) B2C
        const labelRaw = ($a.text() || '').trim();
        const label = labelRaw.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');

        // Mantener las medidas si existen en el DOM
        const currentFeatures = $card.find(SEL.features).text() || '';
        const medidas = currentFeatures.split('|')[0].trim();

        renderFeatures($card, medidas, label);

    } catch (_) {}
  });


  // Click COLOR
  $(document).on('click', SEL.colorSwatch, async function (e) {
    const $sw = $(this);
    const $card = $sw.closest(SEL.card);

    // En B2B con la variant-card de formatos hay múltiples <spark-product-card>
    // pre-renderizados (uno por formato). Re-bindearlos en caliente requeriría
    // reconstruir el selector de formatos completo, así que en ese caso dejamos
    // que el href del swatch navegue al producto-color.
    const isB2B = !!window.themeVariables?.settings?.isB2B;
    if (isB2B && $card.find('.spark-product-card-b2b').length) {
      return;
    }

    e.preventDefault();
    if ($sw.hasClass('active') || $sw.hasClass('is-selected')) return;

    let handle = parseHandleFromHref($sw.data('variant-url') || $sw.attr('href'));
    if (!handle) return;

    try {
      const product = await loadProduct($card, handle);
      updateColorDiscountBadge($card, product);
      setActive($card.find(SEL.colorSwatch), $sw);
      const colorName = $sw.find('.sr-only').text();
      if (colorName) $card.find(SEL.colorActual).text(colorName);

      // En B2B reapuntamos el <spark-product-card> al producto-color elegido y
      // forzamos el re-render reemplazando el nodo (dispara connectedCallback
      // con el nuevo parent-id).
      if (isB2B && product?.id) {
        const sparkEl = $card.find('spark-product-card')[0];
        if (sparkEl) {
          sparkEl.setAttribute('parent-id', product.id);
          const fresh = sparkEl.cloneNode(false);
          sparkEl.replaceWith(fresh);
        }
      }
    } catch (_) {}
  });

 // Estado inicial (marca el formato del handle de la card y normaliza features)
  $(function () {
    $(SEL.card).each(function () {
      const $card = $(this);

      // ---------------------------------------------------------
      // 1. PRIORIDAD: Corrección para botones B2B (.format-selection-b2b)
      // ---------------------------------------------------------
      const $activeB2B = $card.find('.format-selection-b2b.active');
      
      if ($activeB2B.length) {
          // Si hay un botón B2B marcado como activo, este MANDA.
          const labelB2B = $activeB2B.text().trim();
          const $sizeSpan = $card.find('#format-size, .product-grid-item__size');
          if ($sizeSpan.length) {
              setFormatSpanTextOnce($sizeSpan, labelB2B);
          }
          return; 
      }

      // ---------------------------------------------------------
      // 2. FALLBACK: Lógica estándar para enlaces (<a>)
      // ---------------------------------------------------------
      const initialHandle = $card.attr('data-handle') || $card.attr('handle');
      if (!initialHandle) return;

      const $links = $card.find(SEL.formatLink);
      if ($links.length) {
        let $match = $links.filter(function () {
          return parseHandleFromHref(jQuery(this).attr('href')) === initialHandle;
        }).first();
        if (!$match.length) $match = $links.first();
        setActive($links, $match);

        const featuresText = ($card.find(SEL.features).text() || '').trim();
        const medidasDom = featuresText.split('|')[0].trim();
        renderFeatures($card, medidasDom, $match.text().trim());
      }
    });
  });

})(jQuery);

/* =========================================================
   B2B: subir el selector de color en la ficha de producto.
   En B2B "Añadir al carrito" lo pinta <spark-pdp> dentro del
   bloque price; queremos que el cliente vea las opciones de
   color ANTES de ese botón. Movemos el bloque product-variations
   justo delante del bloque price.
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.themeVariables?.settings?.isB2B) return;
  document.querySelectorAll('.product-info__block-list').forEach(function (list) {
    const variations = list.querySelector(':scope > [data-block-type="product-variations"]');
    const price = list.querySelector(':scope > [data-block-type="price"]');
    if (variations && price && variations !== price.previousElementSibling) {
      list.insertBefore(variations, price);
    }
  });
});



$(document).ready(function() {
  // Usamos el selector de jQuery y el método .on() que es más moderno y flexible.
  $('.js-link').on('click', function(event) {
    
    // Buena práctica: previene cualquier comportamiento por defecto que pudiera tener el elemento.
    event.preventDefault(); 
    
    // Obtenemos el data-href usando el método de jQuery .data()
    var enlace = $(this).data('href');
    
    // Una última comprobación para asegurarnos de que el enlace no está vacío
    if (enlace && enlace.length > 0) {
      window.location.href = enlace;
    } else {
      // console.log('Se hizo clic en un js-link, pero no tiene un data-href válido.');
    }
  });

  // =========================================================
  //  LISTENER ESPECÍFICO PARA BOTONES B2B (DIVs) - ACTUALIZADO
  // =========================================================
  $(document).on('click', '.format-selection-b2b', async function(e) {
      e.preventDefault(); // Prevenir comportamientos extraños
      
      const $btn = $(this);
      const $card = $btn.closest('.product-card'); // Buscamos la tarjeta padre
      const handle = $btn.data('format'); // Handle del producto objetivo

      // 1. Cambiar visualmente el botón seleccionado (quita active a los otros, se lo pone a este)
      $btn.siblings('.format-selection-b2b').removeClass('active');
      $btn.addClass('active');

      // 2. Intentar cargar el producto completo (título, precio, fotos)
      if (handle) {
          try {
              // Llamamos a la función global que sacamos del Core
              await loadProduct($card, handle); 
          } catch (err) {
              console.error("Error al cargar variante B2B:", err);
          }
      }

      // 3. Obtener el texto del botón que acabamos de clicar
      const newText = $btn.text();

      // 4. Buscar el span de arriba (donde pone "Caja 36...")
      const $targetSpan = $card.find('#format-size, .product-grid-item__size');

      // 5. Actualizar el texto usando la función de limpieza "Anti-Duplicados"
      if ($targetSpan.length) {
           setFormatSpanTextOnce($targetSpan, newText);
      }

      // 6. MOSTRAR/OCULTAR LOS SPARK CARDS CORRESPONDIENTES (Esto es lo que faltaba al clickar)
      // Aunque spark hace esto por su cuenta a veces, mejor forzarlo
      var $sparkCards = $card.find('.spark-product-card-b2b');
      $sparkCards.each(function() {
          if ($(this).attr('data-format') === handle) {
               $(this).show();
          } else {
               $(this).hide();
          }
      });
  });
  
});

// =========================================================
//  INICIALIZACIÓN FORZADA DE ESTADO B2B (PARA EL PRIMER CARGA)
// =========================================================
jQuery(document).ready(function($) {
  setTimeout(function() {
    $('.product-card').each(function() {
      var $card = $(this);
      
      // Buscamos botones B2B
      var $buttons = $card.find('.format-selection-b2b');
      var $activeBtn = $card.find('.format-selection-b2b.active');

      // Si hay botones pero ninguno activo, activamos el primero por defecto
      if ($buttons.length > 0 && $activeBtn.length === 0) {
         $activeBtn = $buttons.first();
         $activeBtn.addClass('active');
      }

      // Si tenemos un botón activo, aplicamos la lógica visual inmediatamente
      if ($activeBtn.length) {
         var format = $activeBtn.data('format');
         
         // 1. Mostrar/Ocultar Spark Cards según el formato activo
         $card.find('.spark-product-card-b2b').each(function() {
            if ($(this).data('format') === format || $(this).attr('data-format') === format) {
                $(this).show();
                $(this).css('display', 'block'); // Forzamos display block
            } else {
                $(this).hide();
            }
         });

         // 2. Actualizar texto de medida inicial
         var $sizeSpan = $card.find('#format-size, .product-grid-item__size');
         if ($sizeSpan.length) {
            setFormatSpanTextOnce($sizeSpan, $activeBtn.text());
         }
      }
    });
  }, 50); // Delay mínimo para asegurar que el DOM está listo
});


document.addEventListener("DOMContentLoaded", function() {
  // SELECCCION MODIFICADA para incluir ambos tipos de enlace
  const links = document.querySelectorAll('a[style*="color: #6CAB3D"], a.link-faded-reverse');

  links.forEach(link => {
    // Tu regex original (marca secuencias de palabras mayúsculas de 2+ letras)
    const regex = /\b([A-ZÁÉÍÓÚÜÑ0-9]{2,}(?:\s+[A-ZÁÉÍÓÚÜÑ0-9]{2,})*)\b/g;

    // Usamos textContent para leer el texto plano (sin etiquetas)
    // y lo reemplazamos en el innerHTML.
    link.innerHTML = link.textContent.replace(regex, function(match) {
      // Solo aplica si TODA la secuencia está en mayúsculas
      return match === match.toUpperCase() ? `<strong>${match}</strong>` : match;
    });
  });
});

// =========================================================
//  VALIDACIÓN Y SINCRONIZACIÓN DE PROPIEDADES (VERSIÓN FINAL CON OVERLAY)
// =========================================================

/**
 * Función final que valida los campos de personalización obligatorios
 * buscando directamente los campos que sabemos que deben rellenarse.
 */
function validateCustomFields() {
  // console.log("--- 🛡️ Iniciando validación final por nombre de campo ---");
  let isValid = true;
  let isCustomProduct = false;

  const obligatoryFields = [
    'input[name="properties[Línea 1]"]',
    'input#visible-name-input',
    'input#visible-photocall-line1-input',
    'input#visible-photocall-date-input'
  ];

  obligatoryFields.forEach(selector => {
    const field = document.querySelector(selector);
    if (field) {
      isCustomProduct = true;
      if (!field.value || field.value.trim() === '') {
        isValid = false;
      }
    }
  });

  if (!isCustomProduct) {
    return true; // No es un producto para validar, permite continuar
  }

  if (!isValid) {
    alert('Por favor, completa todos los campos obligatorios para personalizar tu producto.');
  }
  
  return isValid;
}

/**
 * Función centralizada que PRIMERO valida y LUEGO sincroniza los valores.
 */
function syncAllCustomProperties() {
  if (validateCustomFields() === false) {
    // console.log("--- 🏁 Resultado final: FALLIDA. Compra bloqueada. ---");
    return false;
  }
  
  // console.log("Sincronizando propiedades...");

  // --- Lógica de sincronización ---
  const fontSelectionCanvas = document.getElementById('font-selection');
  if (fontSelectionCanvas) {
    const hiddenTypographyInput = document.querySelector('input[name="properties[Tipografía]"]');
    if (hiddenTypographyInput) hiddenTypographyInput.value = fontSelectionCanvas.value;
  }
  const colorRadiosCanvas = document.querySelector('input[name="color"]:checked');
  if (colorRadiosCanvas) {
    const hiddenColorInput = document.querySelector('input[name="properties[Color]"]');
    if (hiddenColorInput) hiddenColorInput.value = colorRadiosCanvas.value;
  }
  if (typeof syncHiddenAndPreview === 'function') {
    syncHiddenAndPreview();
  }
  const fontSelectionSingleLine = document.getElementById('font-selection-single-line');
  if (fontSelectionSingleLine) {
    const hiddenTypographyInputSingle = document.querySelector('.hidden-typography-single-line');
    if (hiddenTypographyInputSingle) hiddenTypographyInputSingle.value = fontSelectionSingleLine.value;
  }
  
  // console.log("--- 🏁 Resultado final: CORRECTA. Sincronización completa. ---");
  return true;
}

document.addEventListener('DOMContentLoaded', function() {
  
  const PREVENTA_TAG = "PREVENTA 2026";
  const STORAGE_KEY = "user_session_tracker_preventa";

  // Función para leer la memoria
  function getSessionCounts() {
    const data = sessionStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : { preventa: 0, normal: 0 };
  }

  // Función para guardar
  function updateSessionCounts(preventaCount, normalCount) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      preventa: preventaCount,
      normal: normalCount
    }));
    // console.log("Memoria actualizada:", getSessionCounts());
  }

  // ESCUCHA GLOBAL DE CLICS
  document.body.addEventListener('click', function(e) {
    
    // 1. Buscamos SI EL CLIC FUE EN UN BOTÓN (o en el span de precio que hay dentro)
    // El .closest('button') busca el botón padre si clickas en el texto/precio
    const btn = e.target.closest('button');

    // Si no es un botón, no nos interesa
    if (!btn) return;

    // 2. VALIDACIÓN DE SEGURIDAD: ¿Es un botón de "Añadir"?
    // Verificamos si tiene la clase que me has pasado O si el texto contiene "Añadir"
    // Esto evita que salte al dar clic en otros botones (como wishlist o quickview)
    const isAddButton = btn.classList.contains('btn-small') || btn.innerText.includes('Añadir');
    
    if (!isAddButton) return;

    // 3. Buscamos la tarjeta de producto padre
    const card = btn.closest('product-card');
    if (!card) {
      // console.log("Clic detectado en botón, pero no está dentro de <product-card>");
      return;
    }

    // 4. Buscamos los datos del producto
    const jsonElement = card.querySelector('#ProductJson');
    if (!jsonElement) {
       // console.log("No encuentro el JSON del producto dentro de la tarjeta");
       return;
    }

    // console.log("--- INTENTO DE AÑADIR DETECTADO ---");

    try {
      const productData = JSON.parse(jsonElement.textContent);
      const isNewItemPreventa = productData.tags.includes(PREVENTA_TAG);
      
      // console.log(`Producto: ${productData.title}`);
      // console.log(`Es Preventa: ${isNewItemPreventa}`);

      // Leemos memoria actual
      let counts = getSessionCounts();
      // console.log("Estado actual del carrito (Simulado):", counts);

      let error = false;

      // REGLA A: Intento meter Preventa, pero hay normales
      if (isNewItemPreventa && counts.normal > 0) {
        error = true;
      }
      
      // REGLA B: Intento meter Normal, pero hay preventa
      if (!isNewItemPreventa && counts.preventa > 0) {
        error = true;
      }

      if (error) {
        console.warn("BLOQUEO ACTIVADO: Mezcla de productos detectada.");
        
        // FRENAMOS TODO
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Mata cualquier script de SparkLayer

        alert(`⚠️ NO PUEDES MEZCLAR PEDIDOS\n\n` +
              `Actualmente llevas:\n` + 
              `- ${counts.preventa} productos de PREVENTA\n` +
              `- ${counts.normal} productos normales\n\n` +
              `No se pueden mezclar en el mismo envío. Por favor, termina este pedido primero.`);
        
        return false;
      }

      // SI PASA LA VALIDACIÓN:
      // Buscamos cantidad (intentamos varios selectores comunes por si acaso)
      let quantityToAdd = 1;
      const qtyInput = card.querySelector('input[name="quantity"]') || card.querySelector('.quantity-selector__input');
      
      if (qtyInput) {
        quantityToAdd = parseInt(qtyInput.value) || 1;
      }

      if (isNewItemPreventa) {
        counts.preventa += quantityToAdd;
      } else {
        counts.normal += quantityToAdd;
      }

      updateSessionCounts(counts.preventa, counts.normal);
      // console.log("Producto permitido. Dejando pasar el evento a SparkLayer...");

    } catch (err) {
      console.error("Error JS:", err);
    }

  }, true); // <--- IMPORTANTE: El 'true' activa la fase de CAPTURA (se ejecuta antes que otros scripts)
});

// --- GUARDIANES (VERSIÓN FINAL CON LISTENER DIRECTO) ---
jQuery(document).ready(function($) {
  // console.log("Inicializando guardianes (versión LISTENER DIRECTO)...");
  const $productForm = $("form[is='product-form']");

  if ($productForm.length) {
    const paymentButtonWrapper = '[data-shopify="payment-button"]';
    const $paymentWrapper = $(paymentButtonWrapper);
    const requiredFieldsSelectors = [
      'input[name="properties[Línea 1]"]',
      'input#visible-name-input',
      'input#visible-photocall-line1-input',
      'input#visible-photocall-date-input'
    ].join(', ');
    const $requiredFields = $(requiredFieldsSelectors);
    
    // Si no es un producto que necesite esta lógica, no hacemos nada más.
    if ($requiredFields.length === 0 || $paymentWrapper.length === 0) {
      // console.log("No es un producto para control avanzado. Saliendo.");
      // Mantenemos el guardián del submit por seguridad básica.
      $productForm.on('submit', function(event) {
        if (syncAllCustomProperties() === false) event.preventDefault();
      });
      return;
    }
    
    // console.log(`Modo personalización detectado. ${$requiredFields.length} campos requeridos encontrados.`);

    const $overlay = $('<div class="custom-validation-overlay"></div>').css({
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 10
    }).hide();
    $paymentWrapper.css('position', 'relative').append($overlay);
    
    const checkFieldsAndToggleButtons = () => {
      let allFieldsValid = true;
      $requiredFields.each(function() {
        if ($(this).is(':visible') && $(this).val().trim() === '') {
          allFieldsValid = false;
        }
      });

      if (allFieldsValid) {
        $paymentWrapper.removeClass('payment-buttons--disabled');
        $overlay.hide();
      } else {
        $paymentWrapper.addClass('payment-buttons--disabled');
        $overlay.show();
      }
    };
    
    checkFieldsAndToggleButtons(); // Comprobación inicial

    // ******** ESTE ES EL CAMBIO CLAVE ********
    // En lugar de escuchar en el formulario, escuchamos DIRECTAMENTE en los campos requeridos.
    // Esto es inmune a 'stopPropagation'.
    $requiredFields.on('input change keyup', function() {
      // console.log(`✅ ¡EVENTO DETECTADO DIRECTAMENTE! en el campo "${$(this).attr('id') || $(this).attr('name')}"`);
      checkFieldsAndToggleButtons();
    });

    // Mantenemos el guardián del 'submit' para el botón "Añadir a la cesta"
    $productForm.on('submit', function(event) {
      if (syncAllCustomProperties() === false) {
        event.preventDefault();
      }
    });

  } else {
    // console.log("🔴 ADVERTENCIA: No se encontró el formulario de producto.");
  }
});

// A11y: Shopify video_tag no propaga alt al <img> fallback dentro de <video>.
// Copiamos aria-label del <video> al <img> para satisfacer Lighthouse.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('video > img:not([alt])').forEach(function (img) {
    var video = img.parentElement;
    img.alt = video.getAttribute('aria-label') || video.getAttribute('alt') || '';
  });
});

// A11y: botones de Swiper inyectados por apps externas (Rivyo, PageFly) no tienen aria-label.
// Los etiquetamos cuando aparecen. Usamos MutationObserver porque las apps los inyectan tarde.
(function () {
  function labelSwiperButtons(root) {
    root.querySelectorAll('.swiper-button-prev:not([aria-label])').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Anterior');
    });
    root.querySelectorAll('.swiper-button-next:not([aria-label])').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Siguiente');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    labelSwiperButtons(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) labelSwiperButtons(added[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

